import AppRoutes from './AppRoutes';
import Router from './Router';
export {Router, AppRoutes};

//export default Router;



// WEBPACK FOOTER //
// ./src/modules/router/index.js